import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useLocation, useRouteError } from "react-router";
import { reportError } from "@/shared/observability";
import { ApiError } from "@/shared/api";
import { Button, toast } from "@/shared/ui";

/** Per-route error boundary: friendly text, the request id for support, and a copy button. */
export function RouteError() {
  const { t } = useTranslation();
  const error = useRouteError();
  const { pathname } = useLocation();
  useEffect(() => reportError(error, { where: `route:${pathname}` }), [error, pathname]);
  const requestId = error instanceof ApiError ? error.requestId : undefined;

  const copy = async () => {
    if (!requestId) return;
    try {
      await navigator.clipboard.writeText(requestId);
      toast.info(t("pages.requestIdCopied"));
    } catch {
      toast.error("Could not copy", requestId);
    }
  };

  return (
    <div role="alert" className="mx-auto max-w-lg p-8">
      <h1 className="text-xl font-semibold">{t("pages.errorTitle")}</h1>
      <p className="mt-2 text-muted">{t("pages.errorBody")}</p>
      {requestId ? (
        <p className="mt-4 text-sm">
          {t("pages.requestId")}: <code>{requestId}</code>{" "}
          <Button size="sm" variant="secondary" onClick={() => void copy()}>
            {t("common.copy")}
          </Button>
        </p>
      ) : null}
      <Button className="mt-6" onClick={() => window.location.reload()}>
        {t("common.reload")}
      </Button>
    </div>
  );
}
